module.exports = __webpack_public_path__ + "img/eth.ce5a4e4d.png";